import {Model} from '../base.model';

export class InvoiceState extends Model {
    name: string;
    shortName?: string;
    isPayAllowed?: boolean;
}
